import { render, staticRenderFns } from "./Flogin.vue?vue&type=template&id=2e0d88ca&"
import script from "./Flogin.vue?vue&type=script&lang=js&"
export * from "./Flogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports